export default __webpack_public_path__ + "static/media/Oval@3x.a82ffe0c.png";